"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = omit;

function omit() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var omittedProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Object.keys(source).reduce(function (result, key) {
    if (omittedProperties.indexOf(key) === -1) {
      result[key] = source[key];
    }

    return result;
  }, {});
}